var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStt20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  d: "M16.875 10h-8.75c-.69 0-1.25.56-1.25 1.25v5.625c0 .69.56 1.25 1.25 1.25h8.75c.69 0 1.25-.56 1.25-1.25V11.25c0-.69-.56-1.25-1.25-1.25Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  d: "M4.375 10h-1.25c-.69 0-1.25-.56-1.25-1.25V3.125c0-.69.56-1.25 1.25-1.25h8.75c.69 0 1.25.56 1.25 1.25v4.36"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M8.47 3.375c.57.696.912 1.59.912 2.563S9.04 7.804 8.47 8.5M7.037 4.222c.38.466.608 1.064.608 1.715 0 .652-.229 1.25-.608 1.716M5.625 5.134c.176.218.282.498.282.803s-.106.586-.282.804"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M15.125 16.563h-1.194l-.391-1.058h-2.116l-.384 1.057H9.875l1.917-5h1.401zm-3.053-2.865-.339.932h1.482l-.346-.932a18 18 0 0 1-.384-1.148h-.03c-.125.385-.257.784-.383 1.148"
})));
export default SvgStt20;